import { render, staticRenderFns } from "./editInfoDialog.vue?vue&type=template&id=233dffe4"
import script from "./editInfoDialog.vue?vue&type=script&lang=js"
export * from "./editInfoDialog.vue?vue&type=script&lang=js"
import style0 from "./editInfoDialog.vue?vue&type=style&index=0&id=233dffe4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports